export const ROOM_SIDE_ROOM = "R";
export const ROOM_SIDE_CORRIDOR = "G";
